const t1ByParcelId = new Map<string, number>();

export const recordSearchT1 = (parcelIds: string[]): void => {
  const now = Date.now();
  parcelIds.forEach((id) => t1ByParcelId.set(id, now));
};

export const consumeSearchElapsedMs = (parcelId: string): number | undefined => {
  const t1 = t1ByParcelId.get(parcelId);
  if (t1 === undefined) return undefined;
  t1ByParcelId.delete(parcelId);
  return Date.now() - t1;
};
